<h2 mat-dialog-title>Events for {{ data.date | date:'mediumDate' }}</h2>
<mat-dialog-content>
  <mat-list>
    <mat-list-item *ngFor="let event of data.events">
      <div class="event-item">
        <h3>{{ event.eventName }}</h3>
        <p>Time: {{ event.eventTime.toDate() | date:'shortTime' }}</p>
        <p>Status: {{ event.status || 'Pending' }}</p>
        <p>Event For: {{ event.eventFor }}</p>
      </div>
    </mat-list-item>
  </mat-list>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button (click)="close()">Close</button>
</mat-dialog-actions>

